import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// api
import { useGetMyFeatures } from 'src/api/me';
// components
import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  ai: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData(onCloseNav) {
  const { t } = useLocales();

  // Gate por plano da usina (feature "inventory" = industria 5.0). Só entra no menu
  // quando o usuário tem acesso; ver backend entitlements.py + /api/me/features.
  const { features } = useGetMyFeatures();
  const inventoryEnabled = Boolean(features?.inventory?.enabled);

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: t('overview'),
        items: [
          {
            title: t('consolidated'),
            path: paths.dashboard.root,
            icon: ICONS.analytics,
            onClick: onCloseNav,
          },
          {
            title: t('manual_operations'),
            path: paths.dashboard.manual_operations.root,
            icon: ICONS.menuItem,
            onClick: onCloseNav,
          },
          // Gate por plano da usina (feature "inventory" = industria 5.0).
          ...(inventoryEnabled
            ? [
                {
                  title: 'Estoque',
                  path: paths.dashboard.inventory.root,
                  icon: <Iconify icon="mdi:silo" sx={{ width: 1, height: 1 }} />,
                  onClick: onCloseNav,
                },
              ]
            : []),
          {
            title: t('shipments'),
            path: paths.dashboard.shipments.root,
            icon: ICONS.dashboard,
            onClick: onCloseNav,
          },
          {
            title: t('logistics'),
            path: paths.dashboard.logistics.root,
            icon: ICONS.tour,
            // Sub-tabs live under /logistics/* — keep the item highlighted on all of them.
            deepMatch: true,
            onClick: onCloseNav,
          },
          {
            title: 'Kartrak IA',
            path: paths.dashboard.kartrakIA.root,
            icon: ICONS.ai,
            onClick: onCloseNav,
          },
          // Roadmap sai do menu lateral — acesso via card na página Configurações Gerais.
        ],
      },
    ],
    [t, onCloseNav, inventoryEnabled]
  );
  return data;

}
